var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "page-loader-wrapper",
    class: {
      'hide': _vm.loaded === true
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('Header'), _vm._v(" "), _c('Sidebar'), _vm._v(" "), _c('router-view', {
    staticClass: "animated fadeIn"
  })], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "preloader"
  }, [_c('div', {
    staticClass: "spinner-layer pl-red"
  }, [_c('div', {
    staticClass: "circle-clipper left"
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "circle-clipper right"
  }, [_c('div', {
    staticClass: "circle"
  })])])]), _vm._v(" "), _c('p', [_vm._v("Please wait...")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02cfcb0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = gi2d
// module chunks = 1